define('commons/coverage-map',['jquery', 'commons/coverage-map-overlay', 'commons/coverage-overlay-colorizr', 'marker-clusterer', 'utils/map-style', 'async!google-maps', 'commons/full-screen'], function($, CoverageOverlay, CoverageOverlayColorizr, MarkerClusterer, mapStyles) {
    var CoverageMap = function(mapNodeId, options) {
        
        this.overlays = {};
        this.densities = {};
        this.landCovers = {};
        this.validCoverages = [];
        this.markers = {};
        this.markerClusterer = null;
        this.baseImgUrl = null;
        this.baseImgUrls = [];
        this.envLoss = null;
        this.name = null;
        // Configuration settings
        this.settings = {
            clusterer : {
                imagePath : "/resources/img/mapmarkers/markerclusterer/defaults/m",
                averageCenter:true, 
                zoomOnClick:false,
                maxZoom: 10,
                isDisabled : false,
                minimumClusterSize : 5
            },
            onChangeClusterer: undefined,
            zoom: 5,
            minDb: 0,
            maxDb: 0,
            displayCoverage: true,
            overlayOpacity: 50,
            densityOpacity: 50,
            landCoverOpacity: 50,
            infoMaxWidth: 300,
            freeze: true,
            showSlider: true,
            hideSlider: false,
            disableDefaultUI: false,
            mapTypeControl: true,
            scaleControl: true,
            displayDensity: false,
            displayLandCover: false,
            pos: {
                lat: 0,
                lng: 0
            },
            useTile: false,
            single: false, 
            colorSteps: [0,0,0,0,0,0],
            targets: [],
            densityBaseImgUrl: "",
            landCoverBaseImgUrl: "",
            fullScreen: null,
            enableResizable: true
        };
        $.extend(true,this.settings, options);
        
        // Create the map
        this.POPULATION_DENSITY = 'Population density';
        this.LAND_COVER = 'Land cover';
        this.LIGHT = 'Light';

        this.mapNodeId = mapNodeId;
        this.map = new google.maps.Map(document.getElementById(mapNodeId), {
            center: new google.maps.LatLng(this.settings.pos.lat, this.settings.pos.lng),
            zoom: this.settings.zoom,
            disableDefaultUI: this.settings.disableDefaultUI,
            scaleControl: this.settings.scaleControl,
            mapTypeControl: this.settings.mapTypeControl,
            draggable: true,
            rotateControl : false,
            fullscreenControl : false,
            gestureHandling : "greedy",
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControlOptions: {style: google.maps.MapTypeControlStyle.DROPDOWN_MENU, mapTypeIds: [this.LAND_COVER, this.POPULATION_DENSITY, google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.TERRAIN, google.maps.MapTypeId.HYBRID, google.maps.MapTypeId.SATELLITE, this.LIGHT]}
        });
        this.map.setTilt(0);
        if (!this.settings.clusterer.isDisabled){
            this.map.controls[google.maps.ControlPosition.RIGHT_TOP].push(this.makeToggleCluster());
        }
        
        var densityTypeOptions = {
                maxZoom: 15,
                minZoom: 7,
                name: "Population"
              };
    
        var landCoverTypeOptions = {
                maxZoom: 15,
                minZoom: 7,
                name: "Land cover"
              };
        
        var lightTypeOptions = {
                name: "Light"
              };
        var lightStyle = mapStyles.classicLight;
        var lightMap = new google.maps.StyledMapType(lightStyle, lightTypeOptions);
        this.map.mapTypes.set(this.LIGHT, lightMap);
        
        // population density
        if (this.settings.displayDensity) {
            var densityMap = new google.maps.StyledMapType([], densityTypeOptions);
            this.map.mapTypes.set(this.POPULATION_DENSITY, densityMap);
        }
        // land cover
        if (this.settings.displayLandCover) {
            var landcoverMap = new google.maps.StyledMapType([], landCoverTypeOptions);
            this.map.mapTypes.set(this.LAND_COVER, landcoverMap);
        }
        if (this.settings.displayLandCover || this.settings.displayDensity) {
            google.maps.event.addListener(this.map, 'maptypeid_changed', $.proxy(function() {
                var mapTypeId = this.map.getMapTypeId();
                
                if (mapTypeId == this.POPULATION_DENSITY) {
                    if (!this.settings.hideSlider) {
                        this.densitySliderDiv.show();
                    }
                    this.landCoverSliderDiv.hide();
                    this.switchMapId("density");
                    this.displayDensityCaption(true);
                    this.displayTileLandCoverCaption(false);
                    this.displayLandCoverCaption(false);
                } else if (mapTypeId == this.LAND_COVER) {
                    if (!this.settings.hideSlider) {
                        this.landCoverSliderDiv.show();
                    }
                    this.densitySliderDiv.hide();
                    this.switchMapId("landCover");
                    if (this.settings.useTile) {
                        this.displayTileLandCoverCaption(true);
                        this.displayLandCoverCaption(false);
                    } else {
                        this.displayLandCoverCaption(true);
                        this.displayTileLandCoverCaption(false);
                    }
                    this.displayDensityCaption(false);
                } else {
                    this.densitySliderDiv.hide();
                    this.landCoverSliderDiv.hide();
                    this.switchMapId("none");
                    this.displayDensityCaption(false);
                    this.displayTileLandCoverCaption(false);
                    this.displayLandCoverCaption(false);
                }
            }, this));
        }
    
        // reload on bound change
        google.maps.event.addListener(this.map, 'bounds_changed', $.proxy(function() {
            $('div[role="tooltip"]').remove();
            if (!this.settings.useTile) {
                if (this.settings.displayDensity || this.settings.displayLandCover) {
                    var mapTypeId = this.map.getMapTypeId();
                    if (mapTypeId == this.POPULATION_DENSITY) {
                        this.reloadDensity("density");
                    } else if (mapTypeId == this.LAND_COVER) {
                        this.reloadLandCover("landCover");
                    }
                }
                this.reload();
            }
        }, this));
    
        if (this.settings.showSlider) {
            this._buildSlider();
            if (!this.settings.displayCoverage || this.settings.hideSlider) {
                this.coverageSliderDiv.hide();
                this.densitySliderDiv.hide();
                this.landCoverSliderDiv.hide();
            }
        }
        
        // Create the display window
        this.info = new google.maps.InfoWindow({maxWidth: this.settings.infoMaxWidth});
        this.infoContent = null;

        // Create tooltip
        this.tooltip = $("<div class='coverage-tooltip' style='position: absolute; display: none;'></div>"); 
        $(document.body).append(this.tooltip);

        // add resizable behavior
        if (this.settings.enableResizable) {
            var mapDiv = $("#" + mapNodeId);
            mapDiv.resizable({ helper: "resizable-helper", handles: "s", minHeight: 400, stop: 
                    $.proxy(function( event, ui ) {
                        google.maps.event.trigger(this.map, 'resize');
                        // to stay responsive
                        mapDiv.width("100%");
                    }, this)});
        }

        // The bounds
        this.bounds = null;
        this.boundsCount = 0;
        
        this.freeze = this.settings.freeze;
    
        // add fullscreen control
        if (this.settings.fullScreen && window.fullScreenApi.supportsFullScreen) {
            var fsElement = $("#" + this.settings.fullScreen);
            var fsButton = $.proxy(function(controlDiv, map) {
                // Set CSS for the control border.
                var controlUI = $('<div id="fsControlDiv" class="control-ui" title="Full screen"></div>');
                controlDiv.append(controlUI);

                // Set CSS for the control interior.
                var controlText = $('<div class="control-text"><span class="icon-fullscreen icon-large"></span></div>');
                controlUI.append(controlText);

                // Setup the click event listeners: simply set the map in full screen.
                controlUI.click($.proxy(function() {
                    var span = $("#fsControlDiv").find("span");
                    if (span.hasClass("icon-fullscreen")) {
                        window.fullScreenApi.requestFullScreen(fsElement.get(0));
                        // reset size of the map div
                        mapDiv.css("height","");
                        // move to autocomplete choice to the fullscreen div
                        $(".pac-container").appendTo("#map-wrapper");
                        this._fullscreenToggle(true);
                    } else {
                        window.fullScreenApi.cancelFullScreen(fsElement.get(0));
                        $(".pac-container").appendTo("body");
                        this._fullscreenToggle(false);
                    }
                }, this));
            }, this);

            var controlDiv = $('<div></div>');
            var centerControl = new fsButton(controlDiv, this.map);

            this.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv.get(0));

            //bind enter/exit fullscreen by all means
            $(document).on('webkitfullscreenchange mozfullscreenchange fullscreenchange',$.proxy(function() {
                var span = $("#fsControlDiv").find("span");
                if (span.hasClass("icon-fullscreen")) {
                    span.removeClass("icon-fullscreen");
                    span.addClass("icon-resize-small");
                    // disable resizable transparently
                    mapDiv.resizable( "disable" );
                    mapDiv.removeClass("ui-state-disabled");
                } else {
                    span.removeClass("icon-resize-small");
                    span.addClass("icon-fullscreen");
                    $(".pac-container").appendTo("body");
                    // re-enable resizable
                    mapDiv.resizable( "enable" );
                }
                // wait a bit and then fitBounds
                window.setTimeout($.proxy(function() {
                    this.fitBounds(true);
                }, this), 500);
            }, this));
        }
        
        /** @see markercluster.js for the full options list */ 
        if(!this.settings.clusterer.isDisabled){
            this.markerClusterer = new MarkerClusterer(this.map, null ,this.settings.clusterer);
        }

    };

    CoverageMap.prototype.makeToggleCluster = function(){
        var controlUI = $('<div></div>').addClass("gmnoprint cluster");
        var divUI = $('<div></div>', {
            'class': 'control-ui',
            'title': 'Toggle map clusterer'
        }).appendTo(controlUI);
        this.controlText = $('<div></div>').addClass("control-text").appendTo(divUI);
        this.clusterText();
        google.maps.event.addDomListener(controlUI.get()[0], 'click', $.proxy(this.onToggleClusterClick, this));
        return controlUI.get()[0];
    };
    
    CoverageMap.prototype.onToggleClusterClick = function(){
        var values = [];
        for(var key in this.markers) {
            values.push(this.markers[key].markerInfo);
        }
        this.enableClusterer(!this.settings.clusterer.isDisabled, values);
    };

    CoverageMap.prototype.clusterText = function(){
        this.controlText.html(this.settings.clusterer.isDisabled ? 'Map clusterer : Off' : 'Map clusterer : On');
    };

    CoverageMap.prototype.enableClusterer = function(disabled, markers){
        this.removeMarkers();
        this.settings.clusterer.isDisabled = disabled;
        this.clusterText();
        if(!this.markerClusterer && !disabled){
            this.markerClusterer = new MarkerClusterer(this.map, null ,this.settings.clusterer);
        } else {
            this.markerClusterer = undefined;
        }
        this.addMarkers(markers);
        this.resetMap();
        if (this.settings.onChangeClusterer){
            this.settings.onChangeClusterer.call();
        }
    };

    CoverageMap.prototype._buildSlider = function() {
        // Opacity slider
        this.coverageSliderDiv = $("<div title='Coverage opacity' style='width:160px; margin-top: 5px;'></div>");
        var slider = this.coverageSliderDiv.slider({
            value: this.settings.overlayOpacity
        });
        slider.bind("slide", {_this: this}, function(event, ui) {
            event.data._this.settings.overlayOpacity = ui.value;
            if (event.data._this.settings.useTile) {
                event.data._this.map.overlayMapTypes.forEach(function(elem, n) {
                   if (elem.name == "main_coverage") {
                       elem.updateOpacity(ui.value / 100)
                   } 
                });
                $(".main_coverage img").css('opacity', ui.value / 100);
            } else {
                for (var i in event.data._this.overlays) {
                    event.data._this.overlays[i].setOpacity(ui.value);
                    break;
                }
            }
        });
        this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(this.coverageSliderDiv.get(0));
        
        // Density slider
        this.densitySliderDiv = $("<div id='density-slider' title='Population opacity' style='width:160px; margin-top: 5px; margin-left: 10px; display: none;'></div>");
        var densitySlider = this.densitySliderDiv.slider({
            value: this.settings.densityOpacity
        });
        densitySlider.bind("slide", {_this: this}, function(event, ui) {
            event.data._this.settings.densityOpacity = ui.value;
            if (event.data._this.settings.useTile) {
                event.data._this.map.overlayMapTypes.forEach(function(elem, n) {
                   if (elem.name == "density_coverage") {
                       elem.updateOpacity(ui.value / 100)
                   }
                });
                $(".density_coverage img").css('opacity', ui.value / 100);
            } else {
                for (var i in event.data._this.densities) {
                    event.data._this.densities[i].setOpacity(ui.value);
                    break;
                }
            }
        });
        this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(this.densitySliderDiv.get(0));
    
        // Land cover slider
        this.landCoverSliderDiv = $("<div id='landcover-slider' title='Land cover opacity' style='width:160px; margin-top: 5px; margin-left: 10px; display: none;'></div>");
        var landCoverSlider = this.landCoverSliderDiv.slider({
            value: this.settings.landCoverOpacity
        });
        landCoverSlider.bind("slide", {_this: this}, function(event, ui) {
            event.data._this.settings.landCoverOpacity = ui.value;
            if (event.data._this.settings.useTile) {
                event.data._this.map.overlayMapTypes.forEach(function(elem, n) {
                   if (elem.name == "landcover_coverage") {
                       elem.updateOpacity(ui.value / 100)
                   }
                });
                $(".landcover_coverage img").css('opacity', ui.value / 100);
            } else {
                for (var i in event.data._this.landCovers) {
                    event.data._this.landCovers[i].setOpacity(ui.value);
                    break;
                }
            }
        });
        this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(this.landCoverSliderDiv.get(0));
    };
    
    CoverageMap.prototype.addMarkers = function(markerInfos, reset, keepBounds) {
        for(var i = 0; i < markerInfos.length; i++) {
            this.addMarker(markerInfos[i]);
        }
        if (!keepBounds) {
            this.fitBounds(reset);
        }
    };
    
    CoverageMap.prototype.addMarker = function(markerInfo, fitBounds, excludeFromClusterer) {
        var pos = new google.maps.LatLng(markerInfo.lat, markerInfo.lng);
        
        var markerOptions = {
            map: this.map,
            position: pos,
            icon: this._getIcon(markerInfo),
            draggable: markerInfo.draggable && !this.freeze,
            zIndex: 1,
            title: markerInfo.title,
            optimized: false
        };
        
        // Create the marker
        var marker = new google.maps.Marker(markerOptions);
        // Attach the marker info to the marker
        marker.markerInfo = markerInfo;
        // Save the marker in the marker list
        this.markers[markerInfo.id] = marker;
        
        // Fit to bounds
        this._updateBounds(pos);
        if(!!fitBounds) {
            this.fitBounds();   
        }
        
        if(markerInfo.draggable) { 
            // Place the marker by dragging it
            google.maps.event.addListener(marker, 'dragend', $.proxy(function(markerInfo, event) {
                this._onMarkerDragEnd(event, markerInfo);
            }, this, marker.markerInfo));
        }
        
        google.maps.event.addListener(marker, 'click', $.proxy(this._onMarkerClick, this, marker));
        
        if (!excludeFromClusterer && this.markerClusterer) {
            this.markerClusterer.addMarker(marker);
        }
        return marker;
    };
    
    CoverageMap.prototype._onMarkerClick = function(marker) {
        // Clean up old node
        if(this.infoContent) {
            this.infoContent.remove();
        }
        this.infoContent = $("<div class='infobox'>" + this._getInfoContent(marker.markerInfo) + "</div>");
        this.info.setContent(this.infoContent.get(0));
        this.info.open(this.map, marker);
    };
    
    /**
     * <pre>
     * Remove markers according to the given filter function
     * If the filter function returns true, the marker is deleted, else it is kept
     * If the filter function is not defined, all markers are deleted
     * </pre>
     */
    CoverageMap.prototype.removeMarkers = function(filterFn) {
        if(this.markerClusterer){
            this.markerClusterer.clearMarkers();
        }
        
        for(var id in this.markers) {
            if(this.markers.hasOwnProperty(id)) {
                var marker = this.markers[id];
                if(!filterFn || filterFn.call(filterFn, marker.markerInfo)) {
                    this.removeMarker(id);
                }
            }
        }
    };
    
    CoverageMap.prototype.removeMarker = function(id) {
        var marker = this.markers[id];
        if(marker) {
            google.maps.event.clearInstanceListeners(marker);
            if(this.markerClusterer){
                this.markerClusterer.removeMarker(marker);
            }
            marker.setMap(null);
            delete this.markers[id];
        }
    };
    
    CoverageMap.prototype.updateMarkerVisibility = function(marker, isVisible){
        if(this.markerClusterer){
            // The marker must be added
            if(isVisible){
                this.markerClusterer.addMarker(marker, true);
            }else{
                // remove the marker and force no redraw
                this.markerClusterer.removeMarker(marker,true);
            }
        }
        marker.setVisible(isVisible);
    };
    
    CoverageMap.prototype.redrawMarkers = function(){
        if(this.markerClusterer){
            this.markerClusterer.repaint();
        }
    };
    
    CoverageMap.prototype._updateBounds = function(pos) {
        if(this.bounds === null) {
            this.bounds = new google.maps.LatLngBounds(pos, pos);
        } else {
            this.bounds.extend(pos);
        }
        this.boundsCount++;
    };
    
    CoverageMap.prototype.fitBounds = function(reset) {
        // save maps current zoom levels to avoid super zooms
        var currentMapZoom = this.map.getZoom();
        if(reset) {
            this.bounds = null;
            for(var id in this.markers) {
                if(this.markers.hasOwnProperty(id)) {
                    var marker = this.markers[id];
                    this._updateBounds(new google.maps.LatLng(marker.markerInfo.lat, marker.markerInfo.lng));
                }
            }
        }
        if(this.bounds !== null) {
            if(this.boundsCount < 2) {
                this.map.setCenter(this.bounds.getCenter());
                // originally set at 8, if you turn off map cluster with one station it would reset
                this.map.setZoom(currentMapZoom < 8 ? 8 : currentMapZoom);
            } else {
                this.map.fitBounds(this.bounds);
                if (this.map.getZoom() > currentMapZoom) {
                    this.map.setZoom(currentMapZoom);
                }

            }
        }
    };
    
    CoverageMap.prototype.toggleFreeze = function() {
        this.freeze = !this.freeze;
        for (var i in this.markers) {
            if(this.markers.hasOwnProperty(i)) {
                var marker = this.markers[i];
                marker.setDraggable(marker.markerInfo.draggable && !this.freeze);
            }
        }
        return this.freeze;
    };
    
    CoverageMap.prototype.addCoverages = function(coverages, addToBound) {
        for(var i = 0; i < coverages.length; i++) {
            this.addCoverage(coverages[i], addToBound, false);
        }
        if(addToBound === true) {
            this.fitBounds();
        }
    };
    
    CoverageMap.prototype.addCoverage = function(coverage, addToBound, fitBounds) {
        var sw = new google.maps.LatLng(coverage.bounds.sw.lat, coverage.bounds.sw.lng);
        var ne = new google.maps.LatLng(coverage.bounds.ne.lat, coverage.bounds.ne.lng);
        if(addToBound === true) {
            this._updateBounds(sw);
            this._updateBounds(ne);
            if(!!fitBounds) {
                this.fitBounds();
            }
        }
        var bounds = new google.maps.LatLngBounds(sw, ne);
        var date = new Date();
        
        var url = coverage.baseImgUrl;
        if(url.search(/data:image.*;base64/) == -1) {
            // Add some parameters if the image source is not base64 encoded
            var first = true;
            var params = {"t": new Date().getTime()};
            $.extend(params, coverage.urlParams);
            for(var p in params) {
                if(first) {
                    first = false;
                    url += "?";
                } else {
                    url += "&";
                }
                url += p + "=" + params[p];
            }
        }
        var opacity;
        if (coverage.isDensity) {
            opacity = this.settings.densityOpacity;
        } else if (coverage.isLandCover) {
            opacity = this.settings.landCoverOpacity;
        } else {
            opacity = this.settings.overlayOpacity;
        }
        
        var overlay = new CoverageOverlay(bounds, url, this.map, opacity, coverage.enableOver, coverage.isDensity, coverage.isLandCover);
        overlay.onOverlayMove = $.proxy(this._onToolTipMove, this);
        overlay.onOverlayOut = $.proxy(function() {
            this.tooltip.css("display", "none");
        }, this);
        overlay.coverage = coverage;
        if (coverage.isDensity) {
            this.densities[sw] = overlay;
        } else if (coverage.isLandCover) {
            this.landCovers[sw] = overlay;
        } else {
            this.overlays[sw] = overlay;
        }
        return overlay;
    };
    
    /**
     * <pre>
     * Remove all coverages
     * </pre>
     */
    CoverageMap.prototype.removeCoverages = function() {
        for(var i in this.overlays) {
             this.overlays[i].setMap(null);
        }
        this.overlays = {};
    };
    
    /**
     * Deque style baby, restricted access : skilled dev only ! ;) 
     */
    CoverageMap.prototype.peekFirstCoverage = function() {
        if(!this.overlays){
            return null;
        }
        
        for(var i in this.overlays) {
             return this.overlays[i];
        }
    };

    CoverageMap.prototype.removeTiles = function() {
        var length = this.map.overlayMapTypes.getLength();
        var count = 0;
        for (var i = 0; i < length; i++) {
            var elem = this.map.overlayMapTypes.getAt(i - count);
            if (elem && elem.name == "main_coverage") {
                elem.cleanContext();
                if (this.tilesZoom) {
                    google.maps.event.removeListener(this.tilesZoom);
                }
                this.map.overlayMapTypes.removeAt(i - count);
                count++;
            }
        }
    }

    CoverageMap.prototype.loadTiles = function(baseImgUrls, envLoss, options) {
        if (baseImgUrls && baseImgUrls.length > 0) {
            this.baseImgUrl = baseImgUrls[0];
            this.baseImgUrls = baseImgUrls;
        } else if (this.baseImgUrls.length > 0) {
            baseImgUrls = this.baseImgUrls;
        } else {
            baseImgUrls = [ this.baseImgUrl ];
            this.baseImgUrls = baseImgUrls;
        }
        if (envLoss != null) {
            this.envLoss = envLoss;
        }
        this.removeTiles();
        var name = "main_coverage";

        var ops = {
                envloss: this.envLoss,
                maxOffset: this.settings.maxDb - this.settings.minDb,
                maxOffsets: this.settings.maxOffsets,
                targets: this.settings.targets,
                colorSteps: this.settings.colorSteps,
                projection: this.map.getProjection(),
                mode: $(this.settings.captionSelector).val()
        };
        $.extend(true, ops, options);
        
        if (("overlap_outdoor" == ops.mode || "overlap_indoor"== ops.mode ) && this.baseImgUrls.length > 1) {
            ops.mode = "overlap_multiple";
        }
        
        var layer = new CoverageOverlayColorizr(name, new google.maps.Size(256, 256), this.settings.overlayOpacity / 100, this.settings.single, baseImgUrls, null, ops);

        this.tilesZoom = this.map.addListener('zoom_changed', $.proxy(function() {
            layer.updateZoom(this.map.getZoom());
          }, this));
        if (this.map.getZoom() >= 11) {
            layer.updateZoom(this.map.getZoom());
        }
          
        this.map.overlayMapTypes.push(layer);
    };
    
    CoverageMap.prototype.updateBaseImgUrl = function(baseImgUrls) {
        if (baseImgUrls && baseImgUrls.length > 0) {
            this.baseImgUrl = baseImgUrls[0];
        } else {
            baseImgUrls = [this.baseImgUrl];
        }
    };

    CoverageMap.prototype.resetLayerZoomAfterMapSwitch = function(layer, map){
        if (map.getZoom() >= 11) {
            layer.updateZoom(map.getZoom());
        }
    }

    CoverageMap.prototype.loadDensityTiles = function(options) {
        var name = "density_coverage";

        var ops = {
                colorSteps: this.settings.colorSteps,
                projection: this.map.getProjection(),
                mode: "density"
        };
        $.extend(true, ops, options);
        
        var layer = new CoverageOverlayColorizr(name, new google.maps.Size(256, 256), this.settings.densityOpacity / 100, false, [this.settings.densityBaseImgUrl], null, ops)

        this.densityZoom = this.map.addListener('zoom_changed', $.proxy(function() {
            layer.updateZoom(this.map.getZoom());
          }, this));
        this.resetLayerZoomAfterMapSwitch(layer, this.map);
        this.map.overlayMapTypes.insertAt(0, layer);
    };

    CoverageMap.prototype.loadLandCoverTiles = function(options) {
        var name = "landcover_coverage";
        var ops = {
                colorSteps: this.settings.colorSteps,
                projection: this.map.getProjection(),
                mode: "land_cover"
        };
        $.extend(true, ops, options);
        
        var layer = new CoverageOverlayColorizr(name, new google.maps.Size(256, 256), this.settings.landCoverOpacity / 100, false, [this.settings.landCoverBaseImgUrl], null, ops)

        this.landcoverZoom = this.map.addListener('zoom_changed', $.proxy(function() {
            layer.updateZoom(this.map.getZoom());
          }, this));
        this.resetLayerZoomAfterMapSwitch(layer, this.map);
        this.map.overlayMapTypes.insertAt(0, layer);
    };

    CoverageMap.prototype.loadCoverages = function(coverages, addToBound) {
        // maximum coverages list
        this.validCoverages = coverages;
        if(addToBound === true) {
            for(var i = 0; i < coverages.length; i++) {
                var coverage = coverages[i];
                var sw = new google.maps.LatLng(coverage.bounds.sw.lat, coverage.bounds.sw.lng);
                var ne = new google.maps.LatLng(coverage.bounds.ne.lat, coverage.bounds.ne.lng);
                this._updateBounds(sw);
                this._updateBounds(ne);
            }
        }
        var units = this.inside(this.map.getBounds(), coverages);
        var mode = $(this.settings.captionSelector).val();
        for (var j = 0; j < units.length; j++) {
            var unit = units[j];
            var params = $.extend(unit.coverage.urlParams, { mode: mode });
            this.addCoverage({
                bounds: {
                    sw: {
                        lat: unit.latLng.lat(),
                        lng: unit.latLng.lng()
                    },
                    ne: {
                        lat: unit.latLng.lat() + 1,
                        lng: unit.latLng.lng() + 1
                    }
                },
                baseImgUrl: unit.coverage.baseImgUrl,
                urlParams: params,
                enableOver: false
            });
        }
    };
    
    CoverageMap.prototype.inside = function(viewPort, coverages) {
        var units = [];
        // may not be loaded yet
        if (viewPort) {
            var neLng = Math.ceil(viewPort.getNorthEast().lng() + 1);
            var endLng = neLng > 179 ? neLng - 360 : neLng;
            // ugly "for" loop to manage NZL
            for (var lat = Math.floor(viewPort.getSouthWest().lat() - 1); lat < Math.ceil(viewPort.getNorthEast().lat() + 1); lat++) {
                for (var lng = Math.floor(viewPort.getSouthWest().lng() - 1); lng < endLng || (lng > 0 && endLng < 0); lng = (lng == 179 ? -180 : lng + 1)) {
                    for (var i = 0; i < coverages.length; ++i) {
                        var coverage = coverages[i];
                        if (lat == coverage.bounds.sw.lat && lng == coverage.bounds.sw.lng) {
                            units.push({latLng: new google.maps.LatLng(lat, lng), coverage: coverage});
                            break;
                        }
                    } 
                }
            }
        }
        return units;
    };
    
    CoverageMap.prototype.reload = function() {
        var units = this.inside(this.map.getBounds(), this.validCoverages);
        var sUnits = $.map(units, function(val) {
            return val.latLng.toString();
        });
        for (var i in this.overlays) {
            if (sUnits.indexOf(i) == -1) {
                this.overlays[i].setMap(null);
                delete this.overlays[i];
            }
        }
        var mode = $(this.settings.captionSelector).val();
        var coverageOffsetSelector = $(this.settings.offsetSelector);
        for (var j = 0; j < units.length; j++) {
            var unit = units[j];
            var params = $.extend(unit.coverage.urlParams, { mode: mode, offset: coverageOffsetSelector.val() ? parseInt(coverageOffsetSelector.val()) : 0});
            if (!this.overlays[unit.latLng]) {
                var coverage = this.overlays;
                this.addCoverage({
                    bounds: {
                        sw: {
                            lat: unit.latLng.lat(),
                            lng: unit.latLng.lng()
                        },
                        ne: {
                            lat: unit.latLng.lat() + 1,
                            lng: unit.latLng.lng() + 1
                        }
                    },
                    baseImgUrl: unit.coverage.baseImgUrl,
                    urlParams: params,
                    enableOver: false
                }); 
            }
        }
    };
    
    /**
     * <pre>
     * Remove all density maps
     * </pre>
     */
    CoverageMap.prototype.setBinUrl = function(url) {
        this.settings.binUrl = url;
    };
    
    CoverageMap.prototype.removeDensity = function() {
        var length = this.map.overlayMapTypes.getLength();
        var count = 0;
        for (var i = 0; i < length; i++) {
            var elem = this.map.overlayMapTypes.getAt(i - count);
            if (elem && elem.name == "density_coverage") {
                elem.cleanContext();
                if (this.densityZoom) {
                    google.maps.event.removeListener(this.densityZoom);
                }
                this.map.overlayMapTypes.removeAt(i - count);
                count++;
            }
        }
        for(var i in this.densities) {
            this.densities[i].setMap(null);
        }
        this.densities = {};
    };
    
    CoverageMap.prototype.removeLandCover = function() {
        var length = this.map.overlayMapTypes.getLength();
        var count = 0;
        for (var i = 0; i < length; i++) {
            var elem = this.map.overlayMapTypes.getAt(i - count);
            if (elem && elem.name == "landcover_coverage") {
                elem.cleanContext();
                if (this.landcoverZoom) {
                    google.maps.event.removeListener(this.landcoverZoom);
                }
                this.map.overlayMapTypes.removeAt(i - count);
                count++;
            }
        }
        for(var i in this.landCovers) {
            this.landCovers[i].setMap(null);
        }
        this.landCovers = {};
    };
    
    CoverageMap.prototype.switchMapId = function(mode) {
        if (mode ==  "none") {
            this.removeDensity();
            this.removeLandCover();
        } else if (mode ==  "density") {
            this.removeLandCover();
            if (this.settings.useTile) {
                this.loadDensityTiles();
            } else {
                var units = this.insideDensity(this.map.getBounds());
                for (var i = 0; i < units.length; i++) {
                    var unit = units[i];
                    var unitId = unit.lat() * 1000 + unit.lng();
                    this.addCoverage({
                        bounds: {
                            sw: {
                                lat: unit.lat(),
                                lng: unit.lng()
                            },
                            ne: {
                                lat: unit.lat() + 1,
                                lng: unit.lng() + 1
                            }
                        },
                        baseImgUrl: this.settings.binUrl + "/density/" + unitId,
                        urlParams: {
                            mode: "density"
                        },
                        enableOver: false,
                        isDensity: true,
                        isLandCover: false
                    });
                }
            }
        } else if (mode ==  "landCover") {
            this.removeDensity();
            if (this.settings.useTile) {
                this.loadLandCoverTiles();
                this.displayTileLandCoverCaption(true);
                this.displayLandCoverCaption(false);
            } else {
                var lcUnits = this.insideDensity(this.map.getBounds());
                for (var j = 0; j < lcUnits.length; j++) {
                    var lcUnit = lcUnits[j];
                    var lcUnitId = lcUnit.lat() * 1000 + lcUnit.lng();
                    this.addCoverage({
                        bounds: {
                            sw: {
                                lat: lcUnit.lat(),
                                lng: lcUnit.lng()
                            },
                            ne: {
                                lat: lcUnit.lat() + 1,
                                lng: lcUnit.lng() + 1
                            }
                        },
                        baseImgUrl: this.settings.binUrl + "/landCover/" + lcUnitId,
                        urlParams: {
                            mode: "landCover"
                        },
                        enableOver: false,
                        isDensity: false,
                        isLandCover: true
                    });
                }
                this.displayLandCoverCaption(true);
                this.displayTileLandCoverCaption(false);
            }
        }
    };
    
    CoverageMap.prototype.reloadDensity = function() {
        if (!this.settings.useTile) {
            var units = this.insideDensity(this.map.getBounds());
            var sUnits = $.map(units, function(val) {return val.toString();});
            for (var i in this.densities) {
                if (sUnits.indexOf(i) == -1) {
                    this.densities[i].setMap(null);
                    delete this.densities[i];
                }
            }
            for (var j = 0; j < units.length; j++) {
                var unit = units[j];
                if (!this.densities[unit]) {
                    var unitId = unit.lat() * 1000 + unit.lng();
                    this.addCoverage({
                        bounds: {
                            sw: {
                                lat: unit.lat(),
                                lng: unit.lng()
                            },
                            ne: {
                                lat: unit.lat() + 1,
                                lng: unit.lng() + 1
                            }
                        },
                        baseImgUrl: this.settings.binUrl + "/density/" + unitId,
                        urlParams: {
                            mode: "density"
                        },
                        enableOver: false,
                        isDensity: true
                    }); 
                }
            }
        }
    };
    
    CoverageMap.prototype.reloadLandCover = function() {
        if (!this.settings.useTile) {
            var units = this.insideDensity(this.map.getBounds());
            var sUnits = $.map(units, function(val) {return val.toString();});
            for (var i in this.landCovers) {
                if (sUnits.indexOf(i) == -1) {
                    this.landCovers[i].setMap(null);
                    delete this.landCovers[i];
                }
            }
            for (var j = 0; j < units.length; j++) {
                var unit = units[j];
                if (!this.landCovers[unit]) {
                    var unitId = unit.lat() * 1000 + unit.lng();
                    this.addCoverage({
                        bounds: {
                            sw: {
                                lat: unit.lat(),
                                lng: unit.lng()
                            },
                            ne: {
                                lat: unit.lat() + 1,
                                lng: unit.lng() + 1
                            }
                        },
                        baseImgUrl: this.settings.binUrl + "/landCover/" + unitId,
                        urlParams: {
                            mode: "landCover"
                        },
                        enableOver: false,
                        isDensity: false,
                        isLandCover: true
                    }); 
                }
            }
        }
    };
    
    CoverageMap.prototype.insideDensity = function(viewPort) {
        var units = [];
        // may not be loaded yet
        if (viewPort) {
            var neLng = Math.ceil(viewPort.getNorthEast().lng() + 1);
            var endLng = neLng > 179 ? neLng - 360 : neLng;
            // ugly "for" loop to manage NZL
            for (var lat = Math.floor(viewPort.getSouthWest().lat() - 1); lat < Math.ceil(viewPort.getNorthEast().lat() + 1); lat++) {
                for (var lng = Math.floor(viewPort.getSouthWest().lng() - 1);lng < endLng || (lng > 0 && endLng < 0); lng = (lng == 179 ? -180 : lng + 1)) {
                    units.push(new google.maps.LatLng(lat, lng));
                }
            }
        }
        return units;
    };
    
    CoverageMap.prototype.displayDensityCaption = function(display) {
        var selectedCaption = $(".coverage-caption-density");
        if (display) {
            selectedCaption.show();
        } else {
            selectedCaption.hide();
        }
    };

    CoverageMap.prototype.displayLandCoverCaption = function(display) {
        var selectedCaption = $(".coverage-caption-land-cover");
        if (display) {
            selectedCaption.show();
        } else {
            selectedCaption.hide();
        }
    };

    CoverageMap.prototype.displayTileLandCoverCaption = function(display) {
        var selectedCaption = $(".coverage-caption-land-cover-tile");
        if (display) {
            selectedCaption.show();
        } else {
            selectedCaption.hide();
        }
    };

    CoverageMap.prototype.resetMap = function() {
        google.maps.event.trigger(this.map, 'resize');
        this.fitBounds(true);
    };

    CoverageMap.prototype.getImage = function(imageKey) {
        var mapTypes = this.map.overlayMapTypes.getArray();
        for (var i in mapTypes) {
            if (mapTypes[i].name == "main_coverage") {
                var image = mapTypes[i].images[imageKey];
                if (image) {
                    return image;
                }
            }
        }
        return null;
    };

    /**
     * FUNCTIONS TO BE OVERRIDDEN
     */
    CoverageMap.prototype._getIcon = function(markerInfo) {return null;};
    CoverageMap.prototype._onMarkerDragEnd = function(event, markerInfo) {};
    CoverageMap.prototype._getInfoContent = function(markerInfo) {return null;};
    CoverageMap.prototype._onToolTipMove = function(event, pixel) {};
    CoverageMap.prototype._updateCoverages = function(units) {};
    CoverageMap.prototype._fullscreenToggle = function(activate) {};

    return CoverageMap;
});
